module.exports = __webpack_public_path__ + "img/fa-chart-line.d93626bb.svg";